const { VITE_APP_PERMISSIONS } = import.meta.env;

const permissionsObj = JSON.parse(VITE_APP_PERMISSIONS ?? '[]')?.map((p: string) => ({
  [p]: true,
}));

export const FETCH_AUTHETICATED_USER = 'FETCH_AUTHETICATED_USER';

export const useFetchAuthenticatedUser = () => ({
  isLoading: false,
  isAuthenticated: true,
  user: {
    permission: permissionsObj ?? [],
  },
});
